import React from 'react';
import { Link } from 'react-router-dom';
import UserMenu from '../UserMenu';
import '../../styles/AppShell.css';

function BackChevron() {
  return (
    <svg className="app-shell-back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" aria-hidden="true">
      <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function AppShell({ children, headerExtra, showBrand = true, navBack }) {
  return (
    <div className="app-shell">
      <header className="app-shell-header">
        {/*
         * 3-column grid (RTL: col-1 = right, col-3 = left):
         *   col-1 auto  → logo      — always pinned to right edge
         *   col-2 1fr   → center    — back button OR search bar OR empty
         *   col-3 auto  → actions   — always pinned to left edge
         * Neither logo nor actions ever shift position.
         */}
        <div className="app-shell-header-inner">

          {/* col-1 RIGHT: logo */}
          {showBrand ? (
            <Link to="/welcome" className="app-shell-brand" aria-label="ادواري - صفحة الترحيب">
              <img src="/icons/logo.png" alt="أدواري" className="app-shell-brand-logo" />
            </Link>
          ) : (
            <div className="app-shell-header-spacer" aria-hidden="true" />
          )}

          {/* col-2 CENTER: back button or search bar */}
          <div className="app-shell-header-center">
            {navBack && (
              <button
                type="button"
                className="app-shell-back"
                onClick={navBack.onClick}
                aria-label={navBack.ariaLabel || navBack.label}
              >
                <BackChevron />
                <span className="app-shell-back-label">{navBack.label}</span>
              </button>
            )}
            {headerExtra && (
              <div className="app-shell-header-extra">{headerExtra}</div>
            )}
          </div>

          {/* col-3 LEFT: action icons */}
          <div className="app-shell-header-actions">
            <Link to="/bookings" className="app-shell-bookings-link" title="حجوزاتي">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <span className="app-shell-bookings-label">حجوزاتي</span>
            </Link>
            <UserMenu />
          </div>

        </div>
      </header>

      <main className="app-shell-main">{children}</main>

      <footer className="app-shell-footer">
        <div className="app-shell-footer-inner">
          <span className="app-shell-footer-copy">© {new Date().getFullYear()} أدواري</span>
          <Link to="/contact" className="app-shell-footer-link">تواصل معنا</Link>
          <Link to="/privacy" className="app-shell-footer-link">سياسة الخصوصية</Link>
        </div>
      </footer>
    </div>
  );
}

export default AppShell;
